import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ClientsService } from 'src/app/services/clients.service';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-api-keys',
    templateUrl: './api-keys.component.html',
    styleUrl: './api-keys.component.scss',
    standalone: false
})
export class ApiKeysComponent implements OnInit {

	@ViewChild('createAPIKey') createAPIKeyModal!: TemplateRef<any>;
	@ViewChild('regenerateAPIKey') regenerateAPIKeyModal!: TemplateRef<any>;
	@ViewChild('successModal') successModal!: TemplateRef<any>;
	@ViewChild('errorModal') errorModal!: TemplateRef<any>;

	loading = true;
	access = false;
	no_plan = false;
	apiKey = false;
	submitted = false;
	spinner = false;

	key_once: any = null;
	num: number = 0;
	key = '';

	option = {
    startVal: this.num,
    useEasing: true,
    duration: 2,
    decimalPlaces: 0,
  };

	chart_data: any[] = [];
	// chart_data: any[] = [
	// 	{
	// 		"name": "Jan",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Feb",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Mar",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Apr",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "May",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Jun",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Jul",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Aug",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Sep",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Oct",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Nov",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// 	{
	// 		"name": "Dec",
	// 		"series": [
	// 			{
	// 				"name": "2024",
	// 				"value": 0
	// 			},
	// 			{
	// 				"name": "2025",
	// 				"value": 0
	// 			},
	// 		]
	// 	},
	// ];

	showXAxis = true;
  showYAxis = true;
  gradient = false;
	animations = true;
  showLegend = true;
  showXAxisLabel = false;
	showYAxisLabel = false;
  xAxisLabel = 'Month';
  yAxisLabel = 'Requests';
	legendPosition = LegendPosition.Below;

	colorScheme: string | Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#343a40', '#45cb85']
  };

	success_calls: number = 0;
	failed_calls: number = 0;

	prev_success_calls: number = 0;
	prev_failed_calls: number = 0;
	
	percentageChange_month: number = 0;
	percentageChange_success_calls: number = 0;
	percentageChange_failed_calls: number = 0;

	constructor(private clientService: ClientsService, private modalService: NgbModal, private authService: AuthService) {
		Object.assign(this, { chart_data: this.chart_data });
	}

	ngOnInit(): void {
		this.no_plan = false;
		
		if (this.authService.currentClientValue.plan) {
			this.access = this.authService.currentClientValue.plan.configuration.api_access;
			if (this.access) {
				this.key = '•'.repeat(36);
				this.clientService.getApiKey().subscribe((res) => {
					this.apiKey = res.key;
					this.success_calls = res.success_calls;
					this.failed_calls = res.failed_calls;
					this.prev_success_calls = res.prev_success_calls;
					this.prev_failed_calls = res.prev_failed_calls;
		
					this.percentageChange_month = this.calculatePercentageChange(this.prev_success_calls + this.prev_failed_calls, this.success_calls + this.failed_calls);
					this.percentageChange_success_calls = this.calculatePercentageChange(this.prev_success_calls, this.success_calls);
					this.percentageChange_failed_calls = this.calculatePercentageChange(this.prev_failed_calls, this.failed_calls);
		
					this.loading = false;
				});
			} else {
				this.loading = false;
			}
		} else {
			this.no_plan = true;
			this.loading = false;
		}
	}

	calculatePercentageChange(oldValue: number, newValue: number): number {
		if (oldValue === 0) {
			return newValue > 0 ? 100 : 0; // Handle cases where the old value is zero
		}
		const change = ((newValue - oldValue) / oldValue) * 100;
		return Math.round(change * 100) / 100; // Round to two decimal places
	}

	async copyToClipboard() {
		try {
      await navigator.clipboard.writeText(this.key_once);
      this.authService.toastSuccessMessage('API key copied to clipboard!', '');
    } catch (err: any) {
      this.authService.toastErrorMessage('Failed to copy API key to clipboard', '');
    }
  }

	openCreateKeyModal() {
		if (this.apiKey) {
			this.modalService.open(this.regenerateAPIKeyModal, { size: 'l', backdrop: 'static', keyboard : false });
		} else {
			this.modalService.open(this.createAPIKeyModal, { size: 'l', backdrop: 'static', keyboard : false });
		}
	}

	closeModal() {
		this.key_once = null;
		this.modalService.dismissAll();
	}

	onSubmit() {
		if (this.apiKey) {
			this.clientService.reGenerateApiKey().subscribe({
				next: (res) => {
					this.key_once = res.key;
					this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
				},
				error: () => {
					this.modalService.open(this.errorModal, { size: 'l', backdrop: 'static', keyboard : false });
				}
			});
		} else {
			this.clientService.createApiKey().subscribe({
				next: (res) => {
					this.key_once = res.key;
					this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
				},
				error: () => {
					this.modalService.open(this.errorModal, { size: 'l', backdrop: 'static', keyboard : false });
				}
			});
		}
	}

}